<template>
  <v-dialog
    v-model="getModalCancelarNfe"
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Cencelar NF-e</v-card-title>
      <v-form class="px-3" ref="formCancelamentoNfe">
        <v-card-text>
          <v-layout row wrap>
            <v-text-field
              class="mr-2 ml-2"
              label="Justificativa"
              v-model="dadosCancelamento.justificativa"
              outlined
              dense
              :rules="rules.justificativa"
            ></v-text-field>
          </v-layout>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          dense
          @click="setModalCancelarNfe(false)"
          :loading="$store.getters.getOverlay"
          >Fechar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined dense @click="_cancelarNfe()"
        :loading="$store.getters.getOverlay"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      dadosCancelamento: {
        justificativa: "",
      },
      rules: {
        justificativa: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            (v && v.length >= 15) || "Deve conter no mínimo 15 caracteres.",
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getVenda", "getModalCancelarNfe"]),
  },
  methods: {
    ...mapActions(["setModalCancelarNfe", "cancelarNfe"]),
    _cancelarNfe() {
      if (this.$refs.formCancelamentoNfe.validate()) {
        this.cancelarNfe({
          venda_id: this.getVenda.id,
          justificativa: this.dadosCancelamento.justificativa,
        }).then(() => {
          this.dadosCancelamento.justificativa = "";
        });
      }
    },
  },
  created() {},
};
</script>